export const getSaveDialogStyle = (_, { palette = {} }) => ({
  container: {
    '& .panel-heading': {
      borderBottom: 'none',

      '& .audience-signal-usage .usage': {
        color: palette.themePrimary,
      },
    },

    '& .panel-body': {
      padding: 0,
    },

    '& .asset-groups-grid': {
      '& .ms-DetailsHeader': {
        borderTop: 'none',
        borderBottom: `1px solid ${palette.neutralLight}`,
      },

      '& .ms-DetailsHeader-cell, .ms-DetailsRow-cell': {
        borderRight: 'none',
      },

      '& .campaign-details-list-pagination': {
        margin: 0,

        '& .page-size-control': {
          display: 'none',
        },

        '& .page-control': {
          marginLeft: 0,
        },
      },
    },

    '& .save-options': {
      borderTop: `1px solid ${palette.neutralLight}`,
      marginTop: 16,
      paddingTop: 16,

      '& .save-option': {
        fontWeight: 'normal',
        margin: '-6px 0 0 32px',

        '& div + div': {
          marginTop: 4,
        },
      },
    },

    '& .audience-signal-name': {
      marginLeft: 32,
    },

    '& .server-errors': {
      color: '#A80000',
      marginLeft: 32,
    },
  },
});
